<template>
    <section class="c-tutorials">
        <div class="c-tutorials__title">
            <component
                :is="titleTag || 'h3'"
                class="title"
                v-text="custom.field2"
            />
        </div>

        <div class="c-tutorials__description">
            <p v-text="custom.field3" />
        </div>

        <div class="c-tutorials__content">
            <ul class="case-study-list">
                <li
                    v-for="item in caseStudiesData"
                    :key="item.id"
                    class="list-item"
                >
                    <div class="list-item__image-container">
                        <y-tutorial-video-card
                            :content="item"
                            hidden-title
                            class="video-component"
                        />
                    </div>
                    <div class="list-item__content">
                        <p class="content-title">
                            {{ item.title }}
                        </p>

                        <p
                            class="content-description"
                        >
                            {{ item.synopsis }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>

        <div class="c-tutorials__actions">
            <y-button
                color="primary"
                :tag="isLink(custom['field5']) ? 'a' : 'router-link'"
                :to="custom['field5']"
                :href="custom['field5']"
                :content="custom['field4']"
                size="medium"
                flat
                :no-padding="true"
            />
        </div>
    </section>
</template>

<script >

    import YTutorialVideoCard from '@components/TutorialVideoCard/Index.vue';
    import { isLink } from '@/helpers/helpers';

    export default {
        name      : 'ForPagesTutorials',
        components: {
            YTutorialVideoCard,
        },
        /**
         *
         * @inheritDoc
         */
        props: {
            caseStudiesData: {
                type    : Array,
                required: true,
            },
            custom: {
                type    : Object,
                required: true,
            },
            titleTag: String,
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },
    };

</script>

<style lang="scss" src="./tutorials.scss"/>
